import { createSlice } from '@reduxjs/toolkit';
import FJConstant from '../../constants/FJConstant';
import { DELETE_STYLE_MAP, STYLE_LIST } from '../../config/dataConfig/FJImageToImageData';
import FJUtil from '../../util/FJUtil';
import FJCommunityUtil from '../../util/FJCommunityUtil';
import { PUBLISH_TYPE } from '../../config/dataConfig/FJCommunityData';

export const IMAGE_TO_IMAGE_USE_CREDIT = 2;

const __defaultStyle = () => {
    const recId = FJUtil.getQueryString(FJConstant.REC_ID);
    const queryStyle = FJUtil.getQueryString(FJConstant.STYLE_VALUE);
    const recIdStyle = recId ? JSON.parse(window.localStorage.getItem(recId))?.style : '';
    const resultStyle = DELETE_STYLE_MAP[queryStyle] || queryStyle || DELETE_STYLE_MAP[recIdStyle] || recIdStyle;
    const hasStyle = !!STYLE_LIST.find(ca => ca.list.find(item => item.value === resultStyle));
    return hasStyle ? resultStyle : STYLE_LIST[0].list[0].value;
};
export const FJSliceImageToImage = createSlice({
    name: 'imageToImage',
    initialState: {
        uploadImageInfo: {},
        prompt: '',
        selectStyleCategory: 0,
        selectedStyle: __defaultStyle(),
        generateQuantity: 1, // 默认数量改成1

        openPromptInput: false,
        isExpandEdit: true,
        privacyStatus: FJCommunityUtil.getLocalStoragePrivacyStatus() || PUBLISH_TYPE.ONLY_PUBLIC,

        creationList: [],
        taskStatus: FJConstant.DEFAULT,
        isDone: false, // AI工具已经加工完成并返回了数据
        freeNumCreation: 0,
    },
    reducers: {
        setSliceFreeNumCreationAction: (state, action) => {
            state.freeNumCreation = action.payload;
        },
        setSliceCreationListAction: (state, action) => {
            if (!action.payload) return;
            const isLoading = action.payload.filter(i => i.isLoading).length !== 0;
            const isFailed = action.payload.filter(i => i.isReload).length !== 0;
            state.creationList = action.payload;
            state.isDone = action.payload.length > 0 && !isLoading && !isFailed;
        },
        setSliceIsDoneAction: (state, action) => {
            state.isDone = action.payload;
        },
        setSliceTaskStatusAction: (state, action) => {
            state.taskStatus = action.payload;
        },

        setSliceUploadImageInfoAction: (state, action) => {
            state.uploadImageInfo = action.payload;
        },
        setSlicePromptAction: (state, action) => {
            state.prompt = action.payload;
        },
        setSliceSelectStyleCategoryAction: (state, action) => {
            state.selectStyleCategory = action.payload;
        },
        setSliceSelectedStyleAction: (state, action) => {
            state.selectedStyle = action.payload;
        },
        setSliceGenerateQuantityAction: (state, action) => {
            state.generateQuantity = action.payload;
        },
        setSliceOpenPromptInputAction: (state, action) => {
            state.openPromptInput = action.payload;
        },
        setSliceIsExpandEditAction: (state, action) => {
            state.isExpandEdit = action.payload;
        },
        setSlicePrivacySettingAction: (state, action) => {
            state.privacyStatus = action.payload;
            FJCommunityUtil.setLocalStoragePrivacyStatus(action.payload);
        },
    },
});

export const {
    setSliceUploadImageInfoAction,
    setSlicePromptAction,
    setSliceSelectStyleCategoryAction,
    setSliceSelectedStyleAction,
    setSliceGenerateQuantityAction,
    setSliceOpenPromptInputAction,
    setSliceIsExpandEditAction,
    setSlicePrivacySettingAction,
    setSliceCreationListAction,
    setSliceIsDoneAction,
    setSliceTaskStatusAction,
    setSliceFreeNumCreationAction,
} = FJSliceImageToImage.actions;

export default FJSliceImageToImage.reducer;
